import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-260" data-mp="3ksqhhcu0zq9n">
      <div className="mx-auto max-w-6xl px-4" data-id="element-261" data-mp="3fxku09kz63jg">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-muted" data-id="element-262" data-mp="3b1ckpctgl4k7">Lo que dicen los que ya lo tienen</p>
        <h2 id="reviews-title" className="mt-3 text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-263" data-mp="370k94cx46nkr">
          Seguridad e Higiene con contexto argentino
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-264" data-mp="2x007381rtf1h">
          {reviews.map(([initials, name, role, quote, color], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex min-h-[280px] flex-col rounded-xl border border-line bg-white p-6 text-ink shadow-card" data-id="element-265" data-mp="2s306vdrlr6ia" data-mpi={index}>
              <div className="flex text-safety" aria-label="5 de 5 estrellas" data-id="element-266" data-mp="780j9nv3xa9f">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-267" data-mp="c7n0s9hyxco1" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-268" data-mp="zx7t3j00hm9z">“{quote}”</blockquote>
              <div className="mt-auto flex items-center gap-3 border-t border-line pt-4" data-id="element-269" data-mp="14xlre9bt9hut">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-sm font-extrabold text-white ${color}`} data-id="element-270" data-mp="q6cv5hdeky8p">
                  {initials}
                </span>
                <span data-id="element-271" data-mp="1itqshgl0jvtc">
                  <b className="block text-sm text-ink" data-id="element-272" data-mp="1ith4fyjj3yqa">{name}</b>
                  <small className="text-xs text-muted" data-id="element-273" data-mp="1nnlc6k0mcasf">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}